import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventRecorderService {
  private clicks$ = fromEvent<MouseEvent>(document, 'click');
  private keypresses$ = fromEvent<KeyboardEvent>(document, 'keydown');

  constructor() {
    this.recordClicks();
    this.recordKeyPresses();
  }

  private recordClicks() {
    this.clicks$.pipe(
      filter(event => event instanceof MouseEvent),
      map(event => ({
        x: event.clientX,
        y: event.clientY,
        timestamp: new Date()
      }))
    ).subscribe({
      next: (data) => {
        console.log(`Mouse Clicked at: (${data.x}, ${data.y})`);
      },
      error: (err) => console.error('Error recording click event:', err)
    });
  }
  
  private recordKeyPresses() {
    this.keypresses$.pipe(
      filter(event => event instanceof KeyboardEvent),
      map(event => ({
        key: event.key,
        timestamp: new Date()
      }))
    ).subscribe({
      next: (data) => {
        console.log(`Key Pressed: ${data.key}`);
      },
      error: (err) => console.error('Error recording keypress event:', err)
    });
  }
}